import { cx } from '@twind/core';
import { Subheading } from 'app/components/Typography';

import { MessageReadMarker } from './MessageReadMarker';

type Props = {
  name: string;
  src?: string;
  className?: string;
  messageIndex?: number;
};

const JoiningMessage = ({ name, src, className, messageIndex }: Props) => {
  return (
    <div
      data-message-index={messageIndex}
      className={cx('flex gap-3 items-center', className)}
    >
      {src ? (
        <img
          src={src}
          alt="Concierge Avatar"
          className="w-[24px] h-[24px] object-cover rounded-full"
        />
      ) : null}
      <Subheading className="text-[#575757] font-semibold">{name} has joined the chat</Subheading>
      {messageIndex ? <MessageReadMarker index={messageIndex} /> : null}
    </div>
  );
};

export default JoiningMessage;
